import { useIntegrationStore} from '../stores/integrations';
import { Integration } from '../views/integrations/types/integration';
import { getAccessToken } from '@/services/tokenStorage';

export interface HealthCheckResult {
  status: 'healthy' | 'unhealthy' | 'warning';
  activeIntegrations: Integration[];
  failedIntegrations: Integration[];
  message: string;
  details?: any;
  canIgnore?: boolean;
  hasNonFilesDBIntegrations?: boolean;
}




export class HealthCheckService {
  /**
   * Tüm aktif entegrasyonların sağlık kontrolünü yapar
   * @returns Sağlık kontrolü sonucu
   */
  async checkIntegrationsHealth(): Promise<HealthCheckResult> {
    try {
      const model=useIntegrationStore();
      
      // Token kontrolü
      const token = getAccessToken();
      if (!token) {
        return {
          status: 'healthy',
          activeIntegrations: [],
          failedIntegrations: [],
          message: 'Kullanıcı oturumu açılmamış.',
          hasNonFilesDBIntegrations: false
        };
      }
      
      // Tüm entegrasyonları al
      const allIntegrations = await model.fetchAllIntegrations();
      
      // Error durumundaki entegrasyonları bul
      const errorIntegrations = allIntegrations.filter(
        integration => integration.status === 'error'
      );
      
      // FILES_DB hariç error durumundaki entegrasyonlar
      const nonFilesDBErrors = errorIntegrations.filter(
        integration => integration.name !== 'FILES_DB'
      );
      
      // FILES_DB error durumu
      const filesDBError = errorIntegrations.find(
        integration => integration.name === 'FILES_DB'
      );
      
      // Aktif entegrasyonları bul (FILES_DB hariç)
      const activeNonFilesDB = allIntegrations.filter(
        integration => integration.status === 'active' && integration.name !== 'FILES_DB'
      );
      
      const hasNonFilesDBIntegrations = activeNonFilesDB.length > 0;
      
      // Sonuçları değerlendir
      if (errorIntegrations.length === 0) {
        return {
          status: 'healthy',
          activeIntegrations: allIntegrations.filter(i => i.status === 'active'),
          failedIntegrations: [],
          message: 'Tüm entegrasyonlar sağlıklı durumda.',
          hasNonFilesDBIntegrations
        };
      }
      
      // FILES_DB error durumunda ama başka aktif entegrasyon varsa
      const canIgnore = filesDBError && nonFilesDBErrors.length === 0 && hasNonFilesDBIntegrations;
      
      // Gösterilecek hatalı entegrasyonları belirle
      const displayErrors = canIgnore ? [] : errorIntegrations;
      
      return {
        status: displayErrors.length === 0 ? 'healthy' : 'warning',
        activeIntegrations: allIntegrations.filter(i => i.status === 'active'),
        failedIntegrations: displayErrors,
        message: displayErrors.length > 0 
          ? `${displayErrors.length} entegrasyon hata durumunda.`
          : 'Tüm entegrasyonlar sağlıklı durumda.',
        canIgnore,
        hasNonFilesDBIntegrations
      };
    } catch (error) {
      // API'ye erişirken hata olursa
      return {
        status: 'unhealthy',
        activeIntegrations: [],
        failedIntegrations: [],
        message: 'Entegrasyon servisi ile iletişim kurulamadı.',
        details: error
      };
    }
  }
}

// Singleton instance
export const healthCheckService = new HealthCheckService();
